import LanguageIcon from "@mui/icons-material/Language";
import { IconButton, Menu, MenuItem, type SxProps } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { backendService } from "../../services/backend.service";
import { trackEvent } from "../../utils/analytics";

interface LanguageIconButtonProps {
	color?: "inherit" | "default" | "primary" | "secondary";
	size?: "small" | "medium" | "large";
	sx?: SxProps;
}

export const LanguageIconButton = ({ color = "inherit", size = "small", sx }: LanguageIconButtonProps) => {
	const { i18n } = useTranslation();
	const [languageMenuAnchor, setLanguageMenuAnchor] = useState<null | HTMLElement>(null);
	const languageMenuOpen = Boolean(languageMenuAnchor);

	const handleLanguageMenuClick = (event: React.MouseEvent<HTMLElement>) => {
		setLanguageMenuAnchor(event.currentTarget);
	};

	const handleLanguageMenuClose = () => {
		setLanguageMenuAnchor(null);
	};

	const changeLanguage = async (lang: string) => {
		handleLanguageMenuClose();
		try {
			await backendService.updateUserLanguage(lang);
			await i18n.changeLanguage(lang);
			trackEvent("language_changed", { language: lang });
			window.location.reload();
		} catch (error) {
			console.error("Error updating language:", error);
		}
	};

	return (
		<>
			<IconButton data-testid="header-language-button" color={color} size={size} sx={sx} onClick={handleLanguageMenuClick}>
				<LanguageIcon />
			</IconButton>

			<Menu
				anchorEl={languageMenuAnchor}
				open={languageMenuOpen}
				onClose={handleLanguageMenuClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
			>
				<MenuItem data-testid="language-option-en" onClick={() => changeLanguage("en")} selected={i18n.language === "en"}>
					English
				</MenuItem>
				<MenuItem data-testid="language-option-es" onClick={() => changeLanguage("es")} selected={i18n.language === "es"}>
					Español
				</MenuItem>
			</Menu>
		</>
	);
};
